<app-admin-navigation/>

<app-breadcrumbs/>

<div class="container-fluid no-print" *ngIf="stats">
    <div class="row row-cols-5 row-cols-md-5 g-2 mt-1 mb-3">
        <div class="col">
            <div class="card">
                <div class="card-body text-center">
                    <h5 class="card-title mb-0">
                        <i class="fa-solid fa-file text-muted"></i>
                        {{ stats.files }} <small>Dokumente</small></h5>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <div class="card-body text-center">
                    <h5 class="card-title mb-0">
                        <i class="fa fa-folder text-muted"></i>
                        {{ stats.folders }} <small>Ordner</small>
                    </h5>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <div class="card-body text-center">
                    <h5 class="card-title mb-0">
                        <i class="fa fa-link text-muted"></i>
                        {{ stats.links }} <small>Links</small>
                    </h5>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <div class="card-body text-center">
                    <h5 class="card-title mb-0">
                        <i class="fa-solid fa-qrcode text-muted"></i>
                        {{ stats.assignedCodes }}/{{ stats.availableCodes }} Codes</h5>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <div class="card-body text-center">
                    <h5 class="card-title mb-0">
                        <i class="fa-solid fa-database text-muted"></i>
                        {{ stats.totalFileSize / 1024 / 1024 | fileSize }}/{{ stats.availableCodes * 100 }} MB
                    </h5>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid no-print">
    <button type="button" class="btn btn-warning" (click)="openFolderModal(folderTemplate)">Ordner anlegen</button>
    <button type="button" class="btn btn-primary ms-2" (click)="uploadModal.show()">Dokument(e) hochladen</button>
    <button type="button" class="btn btn-primary ms-2" (click)="openLinkModal(linkTemplate)">Link anlegen</button>
    <button type="button" class="btn btn-secondary ms-2" (click)="moveUp()" *ngIf="breadcrumbsService.level > 0">Zurück</button>

    <button type="button" class="btn btn-secondary float-end ms-2" (click)="exportExcel()">Alle exportieren</button>
    <button type="button" class="btn btn-danger float-end" (click)="deleteElements(selectedElements)" *ngIf="selectedElements.length > 0">
        Ausgewählte Dokumente und Links löschen
    </button>

    <div class="table-responsive">
        <table class="table table-sm table-hover mt-3">
            <thead>
            <tr>
                <th (click)="sortTable('name')">Name <i class="fa" *ngIf="predicate == 'name'" [class]="{'fa-arrow-up': !reverse, 'fa-arrow-down': reverse}"></i></th>
                <th (click)="sortTable('downloads')">Downloads/Klicks <i class="fa" *ngIf="predicate == 'downloads'" [class]="{'fa-arrow-up': !reverse, 'fa-arrow-down': reverse}"></i></th>
                <th (click)="sortTable('created_at')">Erstellt am <i class="fa" *ngIf="predicate == 'created_at'" [class]="{'fa-arrow-up': !reverse, 'fa-arrow-down': reverse}"></i></th>
                <th (click)="sortTable('type')">Typ <i class="fa" *ngIf="predicate == 'type'" [class]="{'fa-arrow-up': !reverse, 'fa-arrow-down': reverse}"></i></th>
                <th (click)="sortTable('size')" style="width: 130px; text-align: right">Größe <i class="fa" *ngIf="predicate == 'size'" [class]="{'fa-arrow-up': !reverse, 'fa-arrow-down': reverse}"></i></th>
                <th style="width: 110px"></th>
            </thead>
            <tbody>
            <tr *ngFor="let element of elements">
                <td>
                    @if (element.type == 'folder') {
                        <i class="fa fa-folder me-2" style="color: #d2b454"></i>
                        <span class="pointer" (click)="stackFolder(element)">{{ element.name }}</span>
                    } @else if (element.type == 'file') {
                        <input type="checkbox" class="form-check-input me-2" [(ngModel)]="element.selected" (ngModelChange)="updateSelectedElements()"/>
                        <i class="fa fa-file-pdf me-2" style="color: #c40607"></i>
                        <span>{{ element.name }}</span>
                    } @else if (element.type == 'link') {
                        <input type="checkbox" class="form-check-input me-2" [(ngModel)]="element.selected" (ngModelChange)="updateSelectedElements()"/>
                        <i class="fa fa-link me-2 text-primary"></i>
                        <span>{{ element.name }}</span>
                    }
                    <i class="fa fa-lock ms-2" [tooltip]="'Passwortgeschützt'" placement="bottom" *ngIf="element.password" style="color: #198754"></i>
                    <i class="fa-solid fa-qrcode ms-2 text-secondary" [tooltip]="element.codesString" placement="right" *ngIf="element.codesString"></i>
                </td>
                <td>{{ element.downloads }}</td>
                <td>{{ element.created_at | date: 'dd.MM.yyyy' }}</td>
                <td>
                    @if (element.type == 'file') {
                        {{ element.mime | fileType }}
                    } @else if (element.type == 'folder') {
                        Ordner
                    } @else if (element.type == 'link') {
                        Link
                    }
                </td>
                <td style="text-align: right">
                    @if (element.type == 'file') {
                        {{ element.size | fileSize }}
                    } @else if (element.type == 'folder') {
                        {{ element.countChildren }} Elemente
                    }
                </td>
                <td style="text-align: right">
                    @if (element.type == 'folder') {
                        <button type="button" class="btn btn-secondary btn-sm me-2"
                                (click)="selectFolder(element)">
                            <i class="fa fa-cogs"></i>
                        </button>

                        <button type="button" class="btn btn-danger btn-sm" (click)="deleteFolder(element)">
                            <i class="fa fa-trash"></i>
                        </button>
                    } @else if (element.type == 'file') {
                        <button type="button" class="btn btn-secondary btn-sm me-2"
                                (click)="selectFile(element)">
                            <i class="fa fa-cogs"></i>
                        </button>

                        <button type="button" class="btn btn-danger btn-sm" (click)="deleteFile([element.id])">
                            <i class="fa fa-trash"></i>
                        </button>
                    } @else if (element.type == 'link') {
                        <button type="button" class="btn btn-secondary btn-sm me-2"
                                (click)="selectLink(element)">
                            <i class="fa fa-cogs"></i>
                        </button>

                        <button type="button" class="btn btn-danger btn-sm" (click)="deleteLink([element.id])">
                            <i class="fa fa-trash"></i>
                        </button>
                    }
                </td>
            </tbody>
        </table>
    </div>

    <div class="text-muted" *ngIf="elements?.length == 0">Ordner ist leer</div>
</div>

<ng-template #folderTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Neuen Ordner anlegen</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="folderModalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <input type="text" class="form-control" [(ngModel)]="newFolder.name" placeholder="Name" required>
        <div class="form-check mt-3">
            <input class="form-check-input" type="checkbox" [(ngModel)]="newFolder.qrcode">
            <label class="form-check-label">
                QR Code zuweisen
            </label>
        </div>
        @if (newFolder.qrcode) {
            <div class="input-group mt-3" >
                <span class="input-group-text text-uppercase">{{slug}}-</span>
                <input type="text" class="form-control" placeholder="Nummer" [(ngModel)]="newFolder.number" required>
            </div>

            <ul class="list-unstyled mt-3 mb-0" style="column-count: 3" *ngIf="availableNumbers.length > 0">
                <li class="text-primary pointer" *ngFor="let number of availableNumbers" (click)="setAvailableNumber('folder', number)">{{number}}</li>
            </ul>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="folderModalRef?.hide()">Abbrechen</button>
        <button type="button" class="btn btn-success" (click)="saveFolder(folderModalRef)"
                [disabled]="!newFolder.name || (newFolder.qrcode && !newFolder.number)">Speichern
        </button>
    </div>
</ng-template>

<ng-template #linkTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Neuen Link anlegen</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="linkModalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <input type="text" class="form-control" [(ngModel)]="newLink.name" placeholder="Name" required>
        <input type="text" class="form-control mt-3" [(ngModel)]="newLink.url" placeholder="URL" required>
        <div class="form-check mt-3">
            <input class="form-check-input" type="checkbox" [(ngModel)]="newLink.qrcode">
            <label class="form-check-label">
                QR Code zuweisen
            </label>
        </div>

        @if (newLink.qrcode) {
            <div class="input-group mt-3" >
                <span class="input-group-text text-uppercase">{{slug}}-</span>
                <input type="text" class="form-control" placeholder="Nummer" [(ngModel)]="newLink.number" required>
            </div>

            <ul class="list-unstyled mt-3 mb-0" style="column-count: 3" *ngIf="availableNumbers.length > 0">
                <li class="text-primary pointer" *ngFor="let number of availableNumbers" (click)="setAvailableNumber('link', number)">{{number}}</li>
            </ul>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="linkModalRef?.hide()">Abbrechen</button>
        <button type="button" class="btn btn-success" (click)="saveLink(linkModalRef)"
                [disabled]="!newLink.name || !newLink.url || (newLink.qrcode && !newLink.number)">Speichern
        </button>
    </div>
</ng-template>

<div bsModal #uploadModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-xl">
        <div class="modal-content" *ngIf="uploader">
            <div class="modal-header">
                <h4 class="modal-title pull-left">Dokumente hochladen</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close"
                        (click)="uploadModal.hide()">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div ng2FileDrop
                     [class.nv-file-over]="hasBaseDropZoneOver"
                     (fileOver)="fileOverBase($event)"
                     [uploader]="uploader"
                     class="well my-drop-zone mb-3">
                    PDFs hier reinziehen
                </div>

                <!--<input type="file" ng2FileSelect [uploader]="uploader" multiple accept="application/pdf"/>-->
                <input style="display: none" type="file" ng2FileSelect #fileInput multiple accept="application/pdf"
                       [uploader]="uploader">
                <button type="button" class="btn btn-info" (click)="fileInput.click()">
                    oder PDFs auswählen
                </button>

                <div class="mt-3" *ngIf="uploader.queue.length > 0">

                    <h3>{{ uploader.queue.length }} ausgewählte Dokumente</h3>

                    <table class="table">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Typ</th>
                            <th>Größe</th>
                            <th>Fortschritt</th>
                            <th>Status</th>
                            <th>Aktionen</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of uploader.queue; let i = index">
                            <!--<td><strong>{{ item?.file?.name }}</strong></td>-->
                            <td>
                                <input type="text" class="form-control" [(ngModel)]="item.formData.name" required
                                       [disabled]="item.isReady || item.isUploading || item.isSuccess">
                            </td>
                            <td>
                                PDF
                            </td>
                            <td *ngIf="uploader.options.isHTML5" nowrap>
                                {{ item?.file?.size / 1024 / 1024 | number:'1.0-2' }} MB
                            </td>
                            <td *ngIf="uploader.options.isHTML5">
                                <div class="progress" style="margin-bottom: 0;">
                                    <div class="progress-bar" role="progressbar"
                                         [style.width]="item.progress + '%'"></div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span *ngIf="item.isSuccess"><i class="fas fa-check"></i></span>
                                <span *ngIf="item.isCancel"><i class="fas fa-ban"></i></span>
                                <span *ngIf="item.isError"><i class="fas fa-trash"></i></span>
                            </td>
                            <td nowrap>
                                <button type="button" class="btn btn-success btn-sm me-1"
                                        (click)="item.upload()"
                                        [disabled]="item.isReady || item.isUploading || item.isSuccess">
                                    Hochladen
                                </button>
                                <button type="button" class="btn btn-warning btn-sm me-1"
                                        (click)="item.cancel()" [disabled]="!item.isUploading">
                                    Abbrechen
                                </button>
                                <button type="button" class="btn btn-danger btn-sm"
                                        (click)="item.remove()">
                                    Entfernen
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div>
                        <div class="mb-3" *ngIf="uploader.progress > 0">
                            Fortschritt
                            <div class="progress" style="">
                                <div class="progress-bar" role="progressbar"
                                     [style.width]="uploader.progress + '%'"></div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-success btn-sm me-2"
                                (click)="uploader.uploadAll()" [disabled]="!uploader.getNotUploadedItems().length">
                            Alle hochladen
                        </button>
                        <button type="button" class="btn btn-warning btn-sm me-2"
                                (click)="uploader.cancelAll()" [disabled]="!uploader.isUploading">
                            Alle abbrechen
                        </button>
                        <button type="button" class="btn btn-danger btn-sm"
                                (click)="uploader.clearQueue(); clearResponses()" [disabled]="!uploader.queue.length">
                            Alle entfernen
                        </button>

                        <button type="button" class="btn btn-secondary btn-sm float-end"
                                (click)="uploader.clearQueue(); clearResponses(); uploadModal.hide()">
                            Schließen
                        </button>
                    </div>
                </div>

                @if (uploadResponses.length > 0) {
                    <hr>
                    <div class="alert alert-success alert-dismissible fade show" role="alert">
                        Es wurden {{uploadResponses.length}} von {{uploader.queue.length}} Dokumenten erfolgreich
                        hochgeladen.
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <!--<pre *ngFor="let response of responses">
                        {{ response | json }}
                    </pre>-->
                }
            </div>
        </div>
    </div>
</div>

<div bsModal #folderDetail="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header no-print">
                <h4 class="modal-title pull-left">Ordner</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeFolder()">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="openedElement">
                <ul class="nav nav-tabs mx-0 mb-1 no-print">
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'details'" href="#"
                           (click)="setOpenedTab($event, 'details')">Details</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'qrcode'"  href="#" (click)="setOpenedTab($event, 'qrcode')">QR-Code(s) <i class="fa-solid fa-circle-info text-warning" *ngIf="!openedElement.code"></i></a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'metadata'"  href="#" (click)="setOpenedTab($event, 'metadata')">Metadaten ({{openedElement.metadata.length}})</a>
                    </li>
                </ul>

                @if (openedTab == 'details') {
                    <form>
                        <div class="mb-3">
                            <label class="form-label">Name</label>
                            <input type="text" class="form-control" name="name" [(ngModel)]="openedElement.name">
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Passwort</label>
                                    <input type="text" class="form-control" name="password" [(ngModel)]="openedElement.password"
                                           placeholder="Optionales Passwort">
                                </div>
                            </div>
                            <!--<div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Verfügbar bis</label>
                                    <input type="date" class="form-control" name="valid_until" [min]="today"
                                           [(ngModel)]="openedElement.valid_until"/>
                                </div>
                            </div>-->
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="form-label">Erstellt am</label>
                                <div>{{openedElement.created_at | date: 'dd.MM.yyyy'}}</div>
                            </div>
                        </div>
                        <!--<div>
                            <label class="form-label">Beschreibung</label>
                            <textarea class="form-control" name="description"
                                      [(ngModel)]="openedElement.description"></textarea>
                        </div>-->
                    </form>
                }

                @if (openedTab == 'qrcode') {
                    <div class="alert alert-warning mt-3" role="alert" *ngIf="openedElement.codes.length == 0">
                        Dieser Ordner ist keinem QR-Code zugewiesen!
                    </div>

                    <button type="button" class="btn btn-primary no-print my-2" *ngIf="!assigningCode" (click)="assignCode()">Neuen QR-Code zuweisen</button>
                    <button type="button" class="btn btn-secondary no-print mt-2" *ngIf="assigningCode" (click)="cancelAssignCode()">Abbrechen</button>

                    @if (assigningCode) {
                        <div class="input-group mt-3" >
                            <span class="input-group-text text-uppercase">{{slug}}-</span>
                            <input type="text" class="form-control" placeholder="Nummer" [(ngModel)]="openedElement.assignedNumber" required>
                        </div>

                        <ul class="list-unstyled my-3" style="column-count: 3" *ngIf="availableNumbers.length > 0">
                            <li class="text-primary pointer" *ngFor="let number of availableNumbers" (click)="setAvailableNumberForExisting(number)">{{number}}</li>
                        </ul>
                    }

                    <accordion [isAnimated]="true" [closeOthers]="true">
                        <accordion-group *ngFor="let code of openedElement.codes" [heading]="(slug + '-' + code.codeNumber).toUpperCase()">
                            <div class="mb-3" style="text-align: center">
                                <img [src]="code.qrdata" style="width: 35%" alt="QR Code"/>
                            </div>
                            <button type="button" class="btn btn-primary no-print" (click)="printCode()">Drucken</button>
                            <button type="button" class="btn btn-info ms-2 no-print" (click)="openCode(code)">Anzeigen</button>
                            <button type="button" class="btn btn-danger no-print float-end" (click)="unassignCode(code)">Zuweisung entfernen</button>
                        </accordion-group>
                    </accordion>
                }

                @if (openedTab == 'metadata') {
                    <button type="button" class="btn btn-primary btn-sm my-2" (click)="addMetaDataItem()">Eintrag hinzufügen</button>

                    <div class="text-muted" *ngIf="openedElement.metadata.length == 0">Keine Metadaten eingetragen</div>

                    <table class="table table-sm table-hover mb-0" *ngIf="openedElement.metadata.length > 0">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Schlüssel</th>
                            <th>Wert</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let data of openedElement.metadata">
                            <td>
                                <button type="button" class="btn btn-danger btn-sm" (click)="deleteMetaDataItem(data)"><i class="fa fa-trash"></i></button>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.key" required/>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.value" required/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                }
            </div>
            <div class="modal-footer no-print">
                <button type="button" class="btn btn-success"
                        (click)="updateFolder()">
                    Aktualisieren
                </button>
                <button type="button" class="btn btn-secondary float-end"
                        (click)="closeFolder()">
                    Schließen
                </button>
            </div>
        </div>
    </div>
</div>

<div bsModal #fileDetail="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header no-print">
                <h4 class="modal-title pull-left">Dokument</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeFile()">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="openedElement">
                <ul class="nav nav-tabs mx-0 mb-1 no-print">
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'details'" href="#"
                           (click)="setOpenedTab($event, 'details')">Details</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'preview'" href="#" (click)="setOpenedTab($event, 'preview')">Vorschau</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'qrcode'"  href="#" (click)="setOpenedTab($event, 'qrcode')">QR-Code(s)</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'metadata'"  href="#" (click)="setOpenedTab($event, 'metadata')">Metadaten ({{openedElement.metadata.length}})</a>
                    </li>
                </ul>

                @if (openedTab == 'details') {
                    <form>
                        <div class="mb-3">
                            <label class="form-label">Name</label>
                            <input type="text" class="form-control" name="name" [(ngModel)]="openedElement.name">
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Passwort</label>
                                    <input type="text" class="form-control" name="password" [(ngModel)]="openedElement.password"
                                           placeholder="Optionales Passwort">
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Verfügbar bis</label>
                                    <input type="date" class="form-control" name="valid_until" [min]="today"
                                           [(ngModel)]="openedElement.valid_until"/>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Downloads</label>
                                    <p>{{openedElement.downloads}}</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Größe</label>
                                    <p>{{openedElement.size | fileSize}}</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Typ</label>
                                    <p>{{openedElement.mime | fileType}}</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Erstellt am</label>
                                    <p>{{openedElement.created_at | date: 'dd.MM.yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label class="form-label">Beschreibung</label>
                            <textarea class="form-control" name="description" rows="5"
                                      [(ngModel)]="openedElement.description"></textarea>
                        </div>
                    </form>
                }

                @if (openedTab == 'preview') {
                    <div *ngIf="embedString" class="pdf-embed">
                        <embed [src]="embedString" type="application/pdf" width="100%" height="100%">
                    </div>
                }

                @if (openedTab == 'qrcode') {
                    <div class="alert alert-warning mt-3" role="alert" *ngIf="openedElement.codes.length == 0">
                        Dieses Dokument ist keinem QR-Code zugewiesen!
                    </div>

                    <button type="button" class="btn btn-primary no-print my-2" *ngIf="!assigningCode" (click)="assignCode()">Neuen QR-Code zuweisen</button>
                    <button type="button" class="btn btn-secondary no-print mt-2" *ngIf="assigningCode" (click)="cancelAssignCode()">Abbrechen</button>

                    @if (assigningCode) {
                        <div class="input-group mt-3" >
                            <span class="input-group-text text-uppercase">{{slug}}-</span>
                            <input type="text" class="form-control" placeholder="Nummer" [(ngModel)]="openedElement.assignedNumber" required>
                        </div>

                        <ul class="list-unstyled my-3" style="column-count: 3" *ngIf="availableNumbers.length > 0">
                            <li class="text-primary pointer" *ngFor="let number of availableNumbers" (click)="setAvailableNumberForExisting(number)">{{number}}</li>
                        </ul>
                    }

                    <accordion [isAnimated]="true" [closeOthers]="true">
                        <accordion-group *ngFor="let code of openedElement.codes" [heading]="(slug + '-' + code.codeNumber).toUpperCase()">
                            <div class="mb-3" style="text-align: center">
                                <img [src]="code.qrdata" style="width: 35%" alt="QR Code"/>
                            </div>
                            <button type="button" class="btn btn-primary no-print" (click)="printCode()">Drucken</button>
                            <button type="button" class="btn btn-info ms-2 no-print" (click)="openCode(code)">Anzeigen</button>
                            <button type="button" class="btn btn-danger no-print float-end" (click)="unassignCode(code)">Zuweisung entfernen</button>
                        </accordion-group>
                    </accordion>
                }

                @if (openedTab == 'metadata') {
                    <button type="button" class="btn btn-primary btn-sm my-2" (click)="addMetaDataItem()">Eintrag hinzufügen</button>

                    <div class="text-muted" *ngIf="openedElement.metadata.length == 0">Keine Metadaten eingetragen</div>

                    <table class="table table-sm table-hover mb-0" *ngIf="openedElement.metadata.length > 0">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Schlüssel</th>
                            <th>Wert</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let data of openedElement.metadata">
                            <td>
                                <button type="button" class="btn btn-danger btn-sm" (click)="deleteMetaDataItem(data)"><i class="fa fa-trash"></i></button>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.key" required/>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.value" required/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                }
            </div>
            <div class="modal-footer no-print">
                <button type="button" class="btn btn-success"
                        (click)="updateFile()">
                    Aktualisieren
                </button>
                <button type="button" class="btn btn-secondary float-end"
                        (click)="closeFile()">
                    Schließen
                </button>
            </div>
        </div>
    </div>
</div>

<div bsModal #linkDetail="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header no-print">
                <h4 class="modal-title pull-left">Link</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeLink()">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="openedElement">
                <ul class="nav nav-tabs mx-0 mb-1 no-print">
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'details'" href="#"
                           (click)="setOpenedTab($event, 'details')">Details</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'qrcode'"  href="#" (click)="setOpenedTab($event, 'qrcode')">QR-Code(s)</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active]="openedTab == 'metadata'"  href="#" (click)="setOpenedTab($event, 'metadata')">Metadaten ({{openedElement.metadata.length}})</a>
                    </li>
                </ul>

                @if (openedTab == 'details') {
                    <form>
                        <div class="mb-3">
                            <label class="form-label">Name</label>
                            <input type="text" class="form-control" name="name" [(ngModel)]="openedElement.name">
                        </div>

                        <div class="mb-3">
                            <label class="form-label">URL</label>
                            <div class="input-group mb-3">
                                <input type="text" class="form-control" name="url" [(ngModel)]="openedElement.url">
                                <a [href]="openedElement.url" target="_blank" class="btn btn-outline-secondary" type="button" *ngIf="openedElement.url">Öffnen</a>
                            </div>
                            <input type="text" class="form-control" >
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Passwort</label>
                                    <input type="text" class="form-control" name="password" [(ngModel)]="openedElement.password"
                                           placeholder="Optionales Passwort">
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Verfügbar bis</label>
                                    <input type="date" class="form-control" name="valid_until" [min]="today"
                                           [(ngModel)]="openedElement.valid_until"/>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Klicks</label>
                                    <p>{{openedElement.downloads}}</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Erstellt am</label>
                                    <p>{{openedElement.created_at | date: 'dd.MM.yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label class="form-label">Beschreibung</label>
                            <textarea class="form-control" name="description" rows="5"
                                      [(ngModel)]="openedElement.description"></textarea>
                        </div>
                    </form>
                }

                @if (openedTab == 'qrcode') {
                    <div class="alert alert-warning mt-3" role="alert" *ngIf="openedElement.codes.length == 0">
                        Dieses Dokument ist keinem QR-Code zugewiesen!
                    </div>

                    <button type="button" class="btn btn-primary no-print my-2" *ngIf="!assigningCode" (click)="assignCode()">Neuen QR-Code zuweisen</button>
                    <button type="button" class="btn btn-secondary no-print mt-2" *ngIf="assigningCode" (click)="cancelAssignCode()">Abbrechen</button>

                    @if (assigningCode) {
                        <div class="input-group mt-3">
                            <span class="input-group-text text-uppercase">{{slug}}-</span>
                            <input type="text" class="form-control" placeholder="Nummer" [(ngModel)]="openedElement.assignedNumber" required>
                        </div>

                        <ul class="list-unstyled my-3" style="column-count: 3" *ngIf="availableNumbers.length > 0">
                            <li class="text-primary pointer" *ngFor="let number of availableNumbers" (click)="setAvailableNumberForExisting(number)">{{number}}</li>
                        </ul>
                    }

                    <accordion [isAnimated]="true" [closeOthers]="true">
                        <accordion-group *ngFor="let code of openedElement.codes" [heading]="(slug + '-' + code.codeNumber).toUpperCase()">
                            <div class="mb-3" style="text-align: center">
                                <img [src]="code.qrdata" style="width: 35%" alt="QR Code"/>
                            </div>
                            <button type="button" class="btn btn-primary no-print" (click)="printCode()">Drucken</button>
                            <button type="button" class="btn btn-info ms-2 no-print" (click)="openCode(code)">Anzeigen</button>
                            <button type="button" class="btn btn-danger no-print float-end" (click)="unassignCode(code)">Zuweisung entfernen</button>
                        </accordion-group>
                    </accordion>
                }

                @if (openedTab == 'metadata') {
                    <button type="button" class="btn btn-primary btn-sm my-2" (click)="addMetaDataItem()">Eintrag hinzufügen</button>

                    <div class="text-muted" *ngIf="openedElement.metadata.length == 0">Keine Metadaten eingetragen</div>

                    <table class="table table-sm table-hover mb-0" *ngIf="openedElement.metadata.length > 0">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Schlüssel</th>
                            <th>Wert</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let data of openedElement.metadata">
                            <td>
                                <button type="button" class="btn btn-danger btn-sm" (click)="deleteMetaDataItem(data)"><i class="fa fa-trash"></i></button>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.key" required/>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.value" required/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                }
            </div>
            <div class="modal-footer no-print">
                <button type="button" class="btn btn-success"
                        (click)="updateLink()">
                    Aktualisieren
                </button>
                <button type="button" class="btn btn-secondary float-end"
                        (click)="closeLink()">
                    Schließen
                </button>
            </div>
        </div>
    </div>
</div>


